import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "./DonationDetails.css";
import html2pdf from "html2pdf.js";
import axios from "axios";

const DonationDetails = () => {
  const location = useLocation();
  const { email_id, transactionId } = location.state || {
    id: "Unknown ID",
    name: "Unknown Name",
  };

  const [subscriptions, setSubscriptions] = useState([false]);
  const [contactDetails, setContactDetails] = useState([false]);
  const [dealDetails, setDealdetails] = useState([false]);
  const [isLoading, setIsLoading] = useState(true);

  const useremail_id = sessionStorage.getItem("userEmail");

  const convertDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  const navigate = useNavigate();

  const handleViewPlan = (email_id, subscription_id, crm_sub_id) => {
    navigate(`/plansdetail`, {
      state: { email_id, subscription_id, crm_sub_id },
    });
  };
  const handlePageNavigation = (email_id, waqf_id, dealName, transactionId) => {
    // sessionStorage.setItem("parentPage",DonationDetails);
    navigate(`/WaqfDetails`, {
      state: { email_id, waqf_id, dealName, transactionId,parentPage:"DonationDetails"},
    });
  };

  sessionStorage.removeItem("parentPage");
 

  const transId = sessionStorage.getItem("transactionId");

  useEffect(() => {
    axios
      .get(`/server/subscription_history/transactionDetails/${useremail_id}/${transactionId}`)
      .then((response) => {
        console.log("=== FULL API RESPONSE ===", response.data);
        console.log("=== TRANSACTION DETAILS ===", response.data.data["Transaction_details"]);
        console.log("=== CONTACT DETAILS ===", response.data.data["Contact_details"]);
        console.log("=== LINE ITEMS (WAQFS) ===", response.data.data["Line Items"]);

        const transactionDetails = response.data.data["Transaction_details"];
        const ContactDetails = response.data.data["Contact_details"];

        console.log("=== ASSOCIATED DEALS ===", transactionDetails?.Associated_deals);
        console.log("=== ASSOCIATED DEALS (Full Structure) ===", JSON.stringify(transactionDetails?.Associated_deals, null, 2));

        const transactionDate = convertDate(transactionDetails?.Transaction_Date);
        const totalAmount = transactionDetails.Total_Amount || null;
        const transactionName = transactionDetails.Transaction_Name;
        const transaction_id = transactionDetails.CRM_Transaction_id;

        const donation_type = transactionDetails.Donation_Type;
        const onBehalf_of = transactionDetails.On_Behalf_Of ? "Yes" : "No";
        const onBehalf_ofWho = transactionDetails.On_Behalf_Of;

        const On_Behalf_Of_Message = transactionDetails.On_Behalf_Of_Message;
        const Payment_method = transactionDetails.Payment_Method || "";
        // The interval lives on the Subscription record, not the Transaction. Never assume a
        // subscription is monthly: this text goes on the tax receipt.
        const frequency = transactionDetails.IsSubscription ? transactionDetails.Frequency || "Recurring" : "One-time";

        const stripeInvoiceId = transactionDetails.Stripe_Invoice_Id;
        const optionalProcessing_Fee = transactionDetails.Processing_Fee || 0;
        const Admin_Fee = transactionDetails.Admin_Fee || 0;
        const deals = transactionDetails.Associated_deals || [];
        const lineItems = transactionDetails["Line Items"] || [];
        const Stripe_subscription_id = transactionDetails.Stripe_subscription_id;
        const payment_status = transactionDetails.Payment_Status;
        const company_name = transactionDetails.Company_Name;
        const abn_acn = transactionDetails.ABN_ACN;
        const daf_mode = transactionDetails.DAF_Mode || "";
        // Sustainability donations split the gift in two: half to the Waqf (which has its own
        // Deal record) and half to operations, which is held only on the Transaction.
        const sustainability_amount = parseFloat(transactionDetails.Sustainability_Amount) || 0;

        // Show the rate the donor was actually charged rather than a hardcoded one. The base is
        // the gift itself, i.e. the total less the fees added on top of it. Falls back to the
        // standard rate when no processing fee was taken, where a derived rate is meaningless.
        const defaultProcessingRate = daf_mode ? 2 : 3;
        const donationBase = Number(totalAmount || 0) - Number(optionalProcessing_Fee) - Number(Admin_Fee);
        const processingFeeRate =
          Number(optionalProcessing_Fee) > 0 && donationBase > 0
            ? Math.round((Number(optionalProcessing_Fee) / donationBase) * 100)
            : defaultProcessingRate;
        const contactName = ContactDetails.Contact_Name;
        const contactEmail = ContactDetails.Email;
        const CRM_contact_id = ContactDetails.CRM_contact_id;
        const street = ContactDetails.Mailing_Street || "";
        const city = ContactDetails.Mailing_City || "";
        const state = ContactDetails.Mailing_State || "";
        const country = ContactDetails.Mailing_Country || "";
        const zip = ContactDetails.Mailing_ZipCode || "";
        const phone = ContactDetails.Phone || "";
        const card_last4 = ContactDetails.Default_Card_Payment.slice(-4) || "";

        const addressParts = [street, city, state, country].filter(Boolean);
        const Address = addressParts.length > 0 ? addressParts.join(", ") : "";

        const formattedLineItems = lineItems.map((item) => ({
          transactionId: item.Transactions.id,
          transactionName: item.Transactions.name,
          email: item.Email || "N/A",
          waqfName: item.Waqfs.name,
          waqfId: item.Waqfs.id,
          waqfsItemId: item.waqfs_id,
          itemName: item.Name,
        }));

        const associatedDeals = transactionDetails?.Associated_deals || [];
        const DealData = associatedDeals.map((dealsItems) => {
          console.log("=== DEAL ITEMS ===", dealsItems);
          // Use Waqf name if available, otherwise use Charity name
          const deal_name = dealsItems.Waqf && dealsItems.Waqf.name ? dealsItems.Waqf.name : (dealsItems.Charity?.name || dealsItems.Deal_Name);
          const Amount = dealsItems.Amount;
          const deal_id = dealsItems.CRM_deal_id;
          const fund_type = dealsItems.Fund_Type;
          const waqf_id = dealsItems.Waqf && dealsItems.Waqf.id ? dealsItems.Waqf.id : null;
          const charity_id = dealsItems.Charity?.id || null;
          const Processing_Fee = dealsItems.Processing_Fee;
          const Admin_fee = dealsItems.Admin_Fee;
          const daf_causes = dealsItems.DAF_Causes || null;
          const deal_donation_type = dealsItems.Donation_Type || "";
          const deal_daf_mode = dealsItems.DAF_Mode || "";

          console.log("=== DAF_CAUSES ===", daf_causes);

          return {
            dealName: deal_name,
            amount: Amount != null ? `${Amount.toFixed()}` : "",
            deal_id: deal_id,
            fund_type: fund_type.toLowerCase(),
            waqf_id: waqf_id,
            charity_id: charity_id,
            type: dealsItems.Type || (charity_id ? 'Charity' : (waqf_id ? 'Waqf' : null)),
            daf_causes: daf_causes,
            donation_type: donation_type,
            donation_type_deal: deal_donation_type,
            daf_mode_deal: deal_daf_mode,
            Processing_Fee: Processing_Fee,
            Admin_fee: Admin_fee,
          };
        });

        // The operations half has no Deal record in the CRM, so synthesise a line item for it.
        // It is tax-deductible, so it belongs on the same DGR receipt as the Waqf half. Fees sit
        // wholly on the Waqf half, so this row carries none.
        if (sustainability_amount > 0) {
          DealData.push({
            dealName: "Awqaf Australia Operations",
            amount: `${sustainability_amount.toFixed()}`,
            deal_id: null,
            fund_type: "dgr",
            waqf_id: null,
            charity_id: null,
            type: "Operations",
            daf_causes: null,
            donation_type: donation_type,
            donation_type_deal: "",
            daf_mode_deal: "",
            Processing_Fee: 0,
            Admin_fee: 0,
          });
        }

        const transactionData = {
          date: transactionDate,
          amount: totalAmount != null ? `$${totalAmount.toFixed(2)}` : "",
          OptionalProcessing_Fee: optionalProcessing_Fee != null ? `$${optionalProcessing_Fee.toFixed(2)}` : "",
          Admin_Fee: Admin_Fee != null ? `$${Admin_Fee.toFixed(2)}` : "",
          lineItems: formattedLineItems,
          // card_last4:card_last4,
          Stripe_subscription_id: Stripe_subscription_id,
          transaction_id: transaction_id,
          donation_type: donation_type,
          onBehalf_of: onBehalf_of,
          onBehalf_ofWho: onBehalf_ofWho,
          On_Behalf_Of_Message: On_Behalf_Of_Message,
          payment_status: payment_status,
          company_name: company_name,
          abn_acn: abn_acn,
          frequency: frequency,
          Payment_method: Payment_method,
          daf_mode: daf_mode,
          processingFeeRate: processingFeeRate,
          sustainability_amount: sustainability_amount,
        };

        const contactData = {
          name: contactName.charAt(0).toUpperCase() + contactName.slice(1).toLowerCase(),
          email: contactEmail,
          address: Address,
          phone: phone,
          street: street,
          city: city,
          state: state,
          country: country,
          CRM_contact_id: CRM_contact_id,
        };
        setSubscriptions(transactionData);
        setContactDetails(contactData);
        setDealdetails(DealData);
      })

      .catch((error) => console.error("Error fetching subscription data:", error))
      .finally(() => setIsLoading(false));
  }, [location]);

  sessionStorage.setItem("transactionId", transactionId);
  sessionStorage.setItem("subscription_id", subscriptions.Stripe_subscription_id);

  const handleDownloadInvoice = async (fundType) => {
    let invoiceContainer;
    try {
      const dealIds = dealDetails.map((deal) => deal.fund_type);
      const filteredDeals = dealDetails.filter((deal) => deal.fund_type === fundType);

      console.log("fund_type", fundType);
      if (filteredDeals.length === 0) {
        alert(`No ${fundType.toUpperCase()} deals found.`);
        return;
      }

      const invoiceContainer = document.createElement("div");
      invoiceContainer.style.position = "fixed";
      invoiceContainer.style.top = "50%";
      invoiceContainer.style.left = "50%";
      invoiceContainer.style.transform = "translate(-50%, -50%)";
      invoiceContainer.style.width = "100%";
      invoiceContainer.style.height = "100%";
      invoiceContainer.style.background = "rgba(255, 255, 255, 0.9)";
      invoiceContainer.style.borderRadius = "10px";
      invoiceContainer.style.padding = "20px";
      invoiceContainer.style.boxShadow = "0px 0px 10px rgba(0, 0, 0, 0.1)";
      invoiceContainer.style.display = "flex";
      invoiceContainer.style.justifyContent = "center";
      invoiceContainer.style.alignItems = "center";
      invoiceContainer.style.zIndex = "1000";

      const loader = document.createElement("div");
      loader.innerHTML = `
        <div class="loader"></div>
        <p style="margin-top: 10px; font-weight: bold; font-size: 16px; color:#0E5C57">Generating Receipt...</p>
      `;
      invoiceContainer.appendChild(loader);

      document.body.appendChild(invoiceContainer);

      const htmlResponse = await fetch("/app/invoice.html");
      if (!htmlResponse.ok) throw new Error("Failed to fetch receipt file");
      let htmlContent = await htmlResponse.text();

      const cssResponse = await fetch("/app/invoice.css");
      if (!cssResponse.ok) throw new Error("Failed to fetch CSS file");
      const cssContent = await cssResponse.text();

      const extractAmount = (amount) => {
        if (typeof amount === "string") {
          return parseFloat(amount.replace("$", "").trim()) || 0;
        }
        return parseFloat(amount) || 0;
      };

      const total = filteredDeals.reduce((sum, deal) => sum + extractAmount(deal.amount), 0);

      // Deal-level fees can undercount the transaction (a Sustainability gift books the whole fee
      // against the Waqf Deal only). Prefer the Transaction's own figures so the receipt matches
      // what the donor was charged. When a transaction spans both a DGR and a non-DGR receipt,
      // fall back to splitting per Deal so the fee is not printed in full on both receipts.
      const spansBothFundTypes = hasDGR && hasNonDGR;
      const totalProcessingFee = spansBothFundTypes
        ? filteredDeals.reduce((sum, deal) => sum + parseFloat(deal.Processing_Fee || 0), 0)
        : extractAmount(subscriptions.OptionalProcessing_Fee);
      const totalAdminFee = spansBothFundTypes
        ? filteredDeals.reduce((sum, deal) => sum + parseFloat(deal.Admin_fee || 0), 0)
        : extractAmount(subscriptions.Admin_Fee);

      const totalAmount = (total + totalProcessingFee + totalAdminFee).toFixed(2);

      let donationRowsHTML = filteredDeals
        .map((item, index, arr) => {
          let rowClass = "detail-row1 second";
          if (index === arr.length - 1) rowClass = "detail-row1 last";

          let pillsHTML = "";
          if (item.type === 'Charity' && item.daf_causes && Array.isArray(item.daf_causes) && item.daf_causes.length > 0) {
            const causesHTML = item.daf_causes
              .map((cause, idx) => `<span class="charity-cause-pill">${cause}${idx < item.daf_causes.length - 1 ? `,&nbsp;` : ''}</span>`)
              .join("");
            pillsHTML = `<div class="charity-causes-container">${causesHTML}</div>`;
          }

          // Determine deal name based on DAF_Mode
          let dealNameDisplay = item.dealName;
          if (subscriptions.daf_mode === "Customise" && item.donation_type_deal) {
            dealNameDisplay = item.dealName + " - " + item.donation_type_deal;
          }

          return `<div class="${rowClass}">
            <div class="detail-row-left">
              <span>${dealNameDisplay}</span>${pillsHTML}
            </div>
            <div class="detail-row-amount">
              <span>AU $${item.amount}</span>
            </div>
          </div>`;
        })
        .join("");

      let organisationName = "Awqaf Australia Forever Fund";
      let organisationABN = "54 133 174 883";
      let organisationEmail = "info@awqaf.org.au";
      let organisationPhone = "1300 297 232";
      let organisationAddress = "132A Haldon St, Lakemba NSW 2195, Australia";
      let receiptHeading = "Thank you for your donation";

      if (fundType === "non-dgr") {
        organisationName = "Awqaf Australia Endowment Fund";
        organisationABN = "98 684 234 384";
      } else {
        receiptHeading = "Tax Receipt";
      }

      htmlContent = htmlContent
        .replace("{{contact_name}}", contactDetails.name)
        .replace("{{contact_email}}", contactDetails.email)
        .replace("{{contact street}}", contactDetails.street)
        .replace("{{contact_city}}", contactDetails.city)
        .replace("{{contact_state}}", contactDetails.state)
        .replace("{{contact_country}}", contactDetails.country)
        .replace("{{contact_address}}", contactDetails.address)
        .replace("{{donation_type}}", subscriptions.donation_type)
        .replace("{{contact_phone}}", contactDetails.phone)
        .replace("{{transaction_date}}", subscriptions.date)
        .replace("{{deal_id}}", subscriptions.transaction_id)
        .replace("{{donar_id}}", contactDetails.CRM_contact_id)
        .replace("{{frequency}}", subscriptions.frequency)
        .replace("{{compony_name}}", subscriptions.company_name)
        .replace("{{abn_acn}}", subscriptions.abn_acn)
        .replace("{{transaction_amount}}", `AU ${subscriptions.amount}`)
        .replace("{{transaction_card}}", subscriptions.Payment_method)
        .replace("{{Stripe_subscription_id}}", subscriptions.Stripe_subscription_id)
        .replace("{{total_amount}}", `AU $${totalAmount}`)
        .replace("{{total_amount1}}", `AU $${totalAmount}`)
        .replace("{{processing_fee}}", `AU $${totalProcessingFee.toFixed(2)}`)
        .replace("{{admin_fee}}", `AU $${totalAdminFee.toFixed(2)}`)
        .replace("{{on_behalf_Of}}", subscriptions.onBehalf_ofWho)
        .replace("{{Message}}", subscriptions.On_Behalf_Of_Message)
        .replace("{{OrganisationName}}", organisationName)
        .replace("{{OrganisationABN}}", organisationABN)
        .replace("{{OrganisationEmail}}", organisationEmail)
        .replace("{{OrganisationPhone}}", organisationPhone)
        .replace("{{OrganisationAddress}}", organisationAddress)
        .replace("{{receipt_heading}}", receiptHeading);

      // Determine header text based on DAF_Mode
      let headerText = "Waqf Funds";
      if (subscriptions.daf_mode) {
        // DAF Mode is either "Adopt" or "Customise"
        headerText = filteredDeals.length === 1 ? "Donation" : "Donations";
      } else if (filteredDeals.some((deal) => deal.type === "Operations")) {
        // A Sustainability gift is a split, not a list of Waqfs. Named for the program the
        // donor signed up to on awqaf.org.au/sustainability.
        headerText = "Private Patrons Program";
      }

      htmlContent = htmlContent.replace(
        `<div class="detail-row1 first"><span>Waqf Funds</span><span>Amount (AUD)</span></div>`,
        `<div class="detail-row1 first"><span>${headerText}</span><span>Amount (AUD)</span></div>${donationRowsHTML}`
      );
      let onBehalfHTML = "";

      if (subscriptions.onBehalf_ofWho) {
        onBehalfHTML += `<div class="detail-row3"><span>On behalf Of</span><span>${subscriptions.onBehalf_ofWho}</span></div>`;
      }

      if (subscriptions.On_Behalf_Of_Message) {
        onBehalfHTML += `<div class="detail-row3"><span>Message</span><span>${subscriptions.On_Behalf_Of_Message}</span></div>`;
      }

      htmlContent = htmlContent.replace("{{on_behalf_Of_section}}", onBehalfHTML);

      let taxNoticeHTML = "";
      if (fundType === "dgr") {
        taxNoticeHTML = `<div style="margin: 8px 5% 0; padding: 10px 14px; background: rgba(14,92,87,0.08); border-left: 3px solid #0E5C57; border-radius: 4px; font-size: 11px; color: #0E5C57;">
          Please retain this receipt for tax deductibility. Donations of $2 or more are tax-deductible.
        </div>`;
      }

      htmlContent = htmlContent.replace("{{tax_notice}}", taxNoticeHTML);

      const container = document.createElement("div");
      container.innerHTML = htmlContent;

      const style = document.createElement("style");
      style.innerHTML = cssContent;
      container.prepend(style);

      const pdfWidth = 500;
      container.style.width = `${pdfWidth}px`;
      container.style.maxWidth = `${pdfWidth}px`;

      const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "");
      const uniqueFileName = `invoice_${timestamp}.pdf`;

      const pdfOptions = {
        margin: 0,
        filename: uniqueFileName,
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 3, width: pdfWidth },
        jsPDF: { unit: "px", format: [pdfWidth, 800], orientation: "portrait" },
      };

      const pdfBlob = await html2pdf().from(container).set(pdfOptions).outputPdf("blob");

      const formData = new FormData();
      formData.append("invoice", pdfBlob, uniqueFileName);

      if (subscriptions.transaction_id) {
        formData.append("transaction_id", subscriptions.transaction_id);
      }
      formData.append("fund_type", fundType);

      const response = await axios.post("/server/subscription/upload-invoice", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const downloadURL = response.data.downloadUrl.data.attributes.download_url + "?directDownload=true";
      const filename = response.data.workdriveResponse.data[0].attributes.FileName;

      const a = document.createElement("a");
      a.href = downloadURL;
      a.target = "_self";
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      if (invoiceContainer) {
        invoiceContainer.style.opacity = "0";

        setTimeout(() => {
          if (invoiceContainer.parentNode) {
            document.body.removeChild(invoiceContainer);
          }
        }, 300);
      }
    } catch (error) {
      console.error("Error downloading the invoice:", error);
      setIsLoading(false);
    } finally {
      if (invoiceContainer) {
        invoiceContainer.style.opacity = "0";

        setTimeout(() => {
          if (invoiceContainer.parentNode) {
            document.body.removeChild(invoiceContainer);
          }
        }, 300);
      }
    }
  };

  useEffect(() => {}, [dealDetails]);

  const hasDGR = dealDetails.some((deal) => deal.fund_type === "dgr");
  const hasNonDGR = dealDetails.some((deal) => deal.fund_type === "non-dgr");

  const type = "Monthly";
  return (
    <div className="bg-[#F7F7F7] -m-[23px] p-[30px] pl-[45px] min-h-screen pr-[45px] flex flex-col no-scrollbar max-sm:block">
      {isLoading && (
        <div className="absolute inset-0 flex h-250vh justify-center items-center bg-white bg-opacity-75 z-50 fixed">
          <div className="animate-spin w-12 h-12 border-[4px] rounded-full border-l-[#095856] border-black"></div>
        </div>
      )}
      <nav class="flex" aria-label="Breadcrumb">
        <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
          <li class="inline-flex items-center">
            <Link to="/subscription" className="ms-1 text-[14px] text-gray-400 hover:text-[#0E5C57] md:ms-2 dark:text-gray-400 dark:hover:text-white">
              Donation
            </Link>
          </li>
          <li aria-current="page">
            <div class="flex items-center">
              <svg
                class="rtl:rotate-180 w-2.5 h-2.5 text-gray-400 mx-1 text-[14px]"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewdiv="0 0 6 10"
              >
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4" />
              </svg>
              <span class="inline-flex items-center text-[14px]  text-gray-400">Donation {subscriptions.transaction_id}</span>
            </div>
          </li>
        </ol>
      </nav>
      <div class="flex flex-col">
        <h5 class="font-Jost text-2xl font-medium leading-[36.4px] mb-2 mt-2">Donations Details</h5>
      </div>
      <div class="bordercolor flex flex-wrap mb-2 mt-2 w-[100%] h-112px max-sm:block">
        <div class=" p-2  max-sm:p-1">
          <div class="donationCard">
            <div class="p-4 donationCardContent h-[112px] gap-[8px] max-sm:gap-[3px] max-sm:h-[80px]">
              <h6 class="donationCardPay">{subscriptions.amount}</h6>
              <p class="donationCardvalue font-[600]">Donation Amount</p>
            </div>
          </div>
        </div>
        {dealDetails.some(deal => deal.type === 'Waqf') && (
          <>
          <div class="p-2 max-sm:p-1">
          <div class="bg-white shadow-lg rounded-lg donationCard">
            <div class="p-4 donationCardContent h-[112px] gap-[8px] max-sm:gap-[3px] max-sm:h-[80px]">
              <h6 class="text-lg font-bold donationCardPay">{subscriptions.amount}</h6>
              <p class="donationCardvalue font-[600]">Gross Value</p>
            </div>
          </div>
        </div>
          <div class="p-2  max-sm:p-1">
            <div class="bg-white shadow-lg rounded-lg donationCard">
              <div class="p-4 donationCardContent h-[112px]  gap-[8px] max-sm:gap-[3px] max-sm:h-[80px]">
                <h6 class="text-lg font-bold donationCardPay">$0.00</h6>
                <p class="donationCardvalue font-[600]">Grants Distributed YTD</p>
              </div>
            </div>
          </div>
          </>
        )}
      </div>

      <div class="bordercolor paymentDiv w-[100%]">
        <div>
          <div class="PaymentHeading flex justify-between">
            <h6 class="PaymentDetails font-bold w-[100%]">Payment Details</h6>
            <div className="flex flex-row gap-4">
              {hasDGR && hasNonDGR ? (
                <>
                  <button
                    className="paymentDownloadBtn cursor-pointer visible max-sm:hidden w-[250px] max-sm:w-[100%]"
                    onClick={() => handleDownloadInvoice("dgr")}
                  >
                    Download DGR Receipt
                  </button>
                  <button
                    className="paymentDownloadBtn cursor-pointer visible max-sm:hidden w-[250px] max-sm:w-[100%]"
                    onClick={() => handleDownloadInvoice("non-dgr")}
                  >
                    Download Non-DGR Receipt
                  </button>
                </>
              ) : hasDGR ? (
                <button
                  className="paymentDownloadBtn cursor-pointer visible max-sm:hidden w-[250px] max-sm:w-[100%]"
                  onClick={() => handleDownloadInvoice("dgr")}
                >
                  Download Receipt
                </button>
              ) : hasNonDGR ? (
                <button
                  className="paymentDownloadBtn cursor-pointer visible max-sm:hidden w-[250px] max-sm:w-[100%]"
                  onClick={() => handleDownloadInvoice("non-dgr")}
                >
                  Download Receipt
                </button>
              ) : null}
            </div>
          </div>
          <div class="p-2">
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[10px] max-sm:items-start">
              <p class="text-sm text-gray-500 paymentLeft">Date</p>
              <p class="text-base paymentRight">{subscriptions.date}</p>
            </div>
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
              <p class="text-sm text-gray-500 paymentLeft">Donation ID</p>
              <p class="text-base paymentRight">{subscriptions.transaction_id} </p>
            </div>
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
              <p class="text-sm text-gray-500 paymentLeft">Type</p>
              <div class="flex items-center gap-[10px]">
                <p class="text-base paymentRight">{subscriptions.frequency}</p>
                {subscriptions.frequency && subscriptions.frequency !== "One-time" && (
                  <div className="flex flex-row align-center ml-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#D9D9D9] mr-2 rounded-2xl mt-[10px] max-sm:mt-[10px]"></span>
                    <button
                      onClick={() => handleViewPlan(email_id, subscriptions.Stripe_subscription_id, subscriptions.transaction_id)}
                      class="text-[#0E5C57] font-medium cursor-pointer"
                    >
                      View Plan
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
              <p class="text-sm text-gray-500 paymentLeft">Payment Method</p>
              <p class="text-base paymentRight">{subscriptions.Payment_method}</p>
            </div>
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
              <p class="text-sm text-gray-500 paymentLeft">Donation Amount</p>
              <p class="text-base paymentRight">{subscriptions.amount}</p>
            </div>
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
              <p class="text-sm text-gray-500 paymentLeft">
                {`${subscriptions.daf_mode ? "Processing Fee" : "Optional Processing Fee"} (${
                  subscriptions.processingFeeRate ?? (subscriptions.daf_mode ? 2 : 3)
                }%)`}
              </p>
              <p class="text-base paymentRight">{subscriptions.OptionalProcessing_Fee}</p>
            </div>
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
              <p class="text-sm text-gray-500 paymentLeft">Awqaf Australia Admin Fee ({subscriptions.daf_mode ? "3%" : "5%"})</p>
              <p class="text-base paymentRight">{subscriptions.Admin_Fee}</p>
            </div>
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
              <p class="text-sm text-gray-500 paymentLeft">Status</p>
              <p class="text-base paymentRight">{subscriptions.payment_status}</p>
            </div>
            <div className="flex flex-row gap-4 max-sm:flex-col">
              {hasDGR && hasNonDGR ? (
                <>
                  <button
                    className="paymentDownloadBtn cursor-pointer hidden max-sm:block w-[250px] max-sm:w-[100%]"
                    onClick={() => handleDownloadInvoice("dgr")}
                  >
                    Download DGR Receipt
                  </button>
                  <button
                    className="paymentDownloadBtn cursor-pointer hidden max-sm:block w-[250px] max-sm:w-[100%]"
                    onClick={() => handleDownloadInvoice("non-dgr")}
                  >
                    Download Non-DGR Receipt
                  </button>
                </>
              ) : hasDGR ? (
                <button
                  className="paymentDownloadBtn cursor-pointer hidden max-sm:block w-[250px] max-sm:w-[100%]"
                  onClick={() => handleDownloadInvoice("dgr")}
                >
                  Download Receipt
                </button>
              ) : hasNonDGR ? (
                <button
                  className="paymentDownloadBtn cursor-pointer hidden max-sm:block w-[250px] max-sm:w-[100%]"
                  onClick={() => handleDownloadInvoice("non-dgr")}
                >
                  Download Receipt
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <div className="bordercolor -mb-[24px]">
        <div className="WaqfsDiv">
          <h6 className="WaqfsTypo p-2">
            {(() => {
              // Check if transaction uses DAF Mode "Adopt"
              if (subscriptions.daf_mode === "Adopt") {
                // Get unique donation types from deals
                const donationTypes = [...new Set(
                  dealDetails
                    .map(deal => deal.donation_type_deal)
                    .filter(type => type && (type === "Zakat" || type === "Sadaqah"))
                )];

                if (donationTypes.length === 2) {
                  return "Zakat and Sadaqah Details";
                } else if (donationTypes.length === 1) {
                  return `${donationTypes[0]} Details`;
                }
                return "Donations";
              }

              // Check if transaction uses DAF Mode "Customise"
              if (subscriptions.daf_mode === "Customise") {
                // Get unique donation types from deals
                const donationTypes = [...new Set(
                  dealDetails
                    .map(deal => deal.donation_type_deal)
                    .filter(type => type && (type === "Zakat" || type === "Sadaqah"))
                )];

                if (donationTypes.length === 2) {
                  return "Zakat and Sadaqah Details";
                } else if (donationTypes.length === 1) {
                  return `${donationTypes[0]} Details`;
                }
                return "Charities Supported";
              }

              // Default behavior: Check for Waqf or Charity
              // A Sustainability gift splits between a Waqf and Operations, so "Waqfs Supported"
              // misdescribes it. Named for the program on awqaf.org.au/sustainability.
              if (dealDetails.some(deal => deal.type === 'Operations')) {
                return "Private Patrons Program";
              }

              return dealDetails.some(deal => deal.type === 'Waqf') ? "Waqfs Supported" : "Charities Supported";
            })()}
          </h6>
          {dealDetails?.length > 0 ? (
            <ul className="list-none  pl-4 bg-[white] z-10">
              {dealDetails.map((item, index) => (
                <li
                  key={index}
                  className={`WaqfsLi font-Jost mb-4 text-[16px] text-[#0E5C57] grid grid-cols-[400px_1fr] gap-5 justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-1 max-sm:items-start relative pb-2 items-start ${item.waqf_id ? 'cursor-pointer' : 'cursor-default'}`}
                  onClick={() => item.waqf_id && handlePageNavigation(email_id, item.waqf_id, item.dealName, transactionId)}
                >
                  <div className="flex flex-col justify-start max-sm:flex-col max-sm:gap-2">
                    <div className="flex justify-start items-center">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#0E5C57] mr-2 flex-shrink-0"></span>
                      <span className="font-500 font-medium">
                        {(() => {
                          // For DAF Mode Customise, append Donation_Type
                          if (subscriptions.daf_mode === "Customise" && item.donation_type_deal) {
                            return `${item.dealName} - ${item.donation_type_deal}`;
                          }
                          // For DAF Mode Adopt or no DAF Mode, show just the name
                          return item.dealName;
                        })()}
                      </span>
                    </div>

                    {item.type === 'Charity' && item.daf_causes && Array.isArray(item.daf_causes) && (
                      <div className="flex flex-wrap gap-2 ml-6 max-sm:ml-0 mb-2 sm:mb-0 mt-0 sm:mt-2">
                        {item.daf_causes.map((cause, idx) => (
                          <span
                            key={idx}
                            className="inline-block px-3 py-1 text-xs bg-[#545454]/5 text-[#545454] rounded-full font-medium border border-[#545454]/40"
                          >
                            {cause}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  <span className="text-black font-400 max-sm:ml-5">${item.amount}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-left text-gray-500 mt-5 ml-20">No Items found.</p>
          )}
        </div>
      </div>

      <div class="bordercolor paymentDiv w-[100%]">
        <div>
          <div class="PaymentHeading flex justify-between">
            <h6 class="PersonalDetails font-bold w-[100%]">Personal Details</h6>
          </div>
          <div class="p-2">
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
              <p class="text-sm text-gray-500 personalLeft">Name</p>
              <p class="personalRight text-base">{contactDetails.name}</p>
            </div>
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
              <p class="text-sm text-gray-500 personalLeft">Address</p>
              <p class="personalRight text-base">{contactDetails.address}</p>
            </div>
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
              <p class="text-sm text-gray-500 personalLeft">Phone</p>
              <p class="personalRight text-base">{contactDetails.phone}</p>
            </div>
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
              <p class="text-sm text-gray-500 personalLeft">Donation Type</p>
              <p class="personalRight text-base">{subscriptions.donation_type}</p>
            </div>
            <div class="p-2 grid grid-cols-[400px_1fr] gap-5 items-center justify-items-start max-sm:flex max-sm:flex-col max-sm:gap-[5px] max-sm:items-start">
              <p class="text-sm text-[#545454] text-[16px] h-[19px] font-medium">Donating on behalf of someone?</p>
              <p class="personalRight text-base">{subscriptions.onBehalf_of}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonationDetails;
